module.exports = __webpack_public_path__ + "media/components/shared/images/PrescriptionSample-6f8003964b873dd770f2f84787d2f61c.jpeg";